import { WysiwygEditorStateContext } from '@src/contexts/wysiwyg/editor';
import React, { useContext, useEffect } from 'react';

import { LandingPad } from '../Portal';
import ImageDropOverlay from '../wysiwyg_editor/ImageDropOverlay';
import TextDropOverlay from '../wysiwyg_editor/TextDropOverlay';
import SvgPage from './SvgPage';

function StencilCanvas(): React.ReactElement {
  const { svgRef, offsetParentRef, viewbox } = useContext(
    WysiwygEditorStateContext
  );

  useEffect(() => {
    if (typeof window === 'undefined') return;

    // The SVG has to be set to a hard coded size because IE displays them out of
    // proportion and makes them fill their parent unless a height and width is set.
    const container = offsetParentRef.current;
    const svg = svgRef.current;
    const viewboxProportions = viewbox.height / viewbox.width;

    function resizeCanvasSvg() {
      // The dimensions need to be removed or the canvas can't ever be smaller
      // than the svg width, which breaks making the window smaller.
      $(svg).css({ height: '', width: '' });
      $(container).css({ height: '', width: '' });

      const containerWidth = $(container).width();
      const svgWidth = containerWidth;
      const svgHeight = svgWidth * viewboxProportions;

      $(svg).css({ height: svgHeight, width: svgWidth });
      $(container).css({ height: svgHeight, width: svgWidth });
    }

    $(window).on('resize.resize-canvas-svg', $.debounce(100, resizeCanvasSvg));
    resizeCanvasSvg();

    return () => {
      $(window).off('resize.resize-canvas-svg');
    };
  }, [offsetParentRef, svgRef, viewbox]);

  return (
    <div className="wysiwyg-editor-canvas">
      <div
        className="wysiwyg-editor-canvas-size-container"
        ref={offsetParentRef}
      >
        <SvgPage />
        <LandingPad htmlId="wysiwyg-editor-portal" />
        <ImageDropOverlay />
        <TextDropOverlay />
      </div>
    </div>
  );
}

export default StencilCanvas;
